import type { RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'simulator',
    component: () => import('@/views/SimulatorView.vue'),
  },
  {
    path: '/feedback/:token',
    name: 'feedback',
    component: () => import('@/views/FeedbackView.vue'),
  },
  {
    path: '/admin',
    component: () => import('@/views/AdminLayout.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'admin-scenarios' },
      },
      {
        path: 'scenarios',
        name: 'admin-scenarios',
        component: () => import('@/views/AdminScenariosPage.vue'),
      },
      {
        path: 'scenarios/:id',
        name: 'admin-scenario-detail',
        component: () => import('@/views/AdminScenarioDetailPage.vue'),
        props: true,
      },
      {
        path: 'transcripts',
        name: 'admin-transcripts',
        component: () => import('@/views/AdminTranscriptsPage.vue'),
      },
      {
        path: 'transcripts/:id',
        name: 'admin-transcript-detail',
        component: () => import('@/views/AdminTranscriptDetailPage.vue'),
        props: true,
      },
      {
        path: 'usage',
        name: 'admin-usage',
        component: () => import('@/views/AdminUsagePage.vue'),
      },
    ],
  },
];

export default createRouter({
  history: createWebHistory(),
  routes,
});
